import React from 'react';
import Box from 'Components/Atoms/Box';
import Typography from 'Components/Atoms/Typography';
import Button from 'Components/Atoms/Button';
import './styles.scss';

export type SiaUpgradeBannerProps = {
  onUpgrade: () => void;
  onWhatsNew: () => void;
};

const SiaUpgradeBanner: React.FC<SiaUpgradeBannerProps> = ({
  onUpgrade,
  onWhatsNew,
}) => {
  return (
    <Box className="sia-upgrade-banner">
      <Box className="sia-upgrade-content">
        <Typography variant="h3" className="sia-upgrade-title">
          🚀 Die neue Sia ist da – mehr als nur Reservierungen
        </Typography>
        <Typography
          variant="text-3"
          className="sia-upgrade-description"
          component="p"
        >
          Sia kann jetzt Reservierungen bearbeiten & stornieren,
          <br />
          Fragen beantworten, Rückrufwünsche notieren –
          <br />
          und führt Gespräche ganz natürlich, ohne Tastendruck.
        </Typography>
        <Typography variant="text-4" className="sia-upgrade-footnote">
          👉 In 5–10 Minuten aktiviert · aktuelles Pricing gilt noch bis 1. Mai
        </Typography>
      </Box>
      <Box className="sia-upgrade-actions">
        <Button variant="primary" onClick={onUpgrade}>
          Jetzt upgraden
        </Button>
        <Button variant="outlined" onClick={onWhatsNew}>
          Was ist neu?
        </Button>
      </Box>
      <img
        src="/sia-graphic.png"
        alt=""
        aria-hidden
        className="sia-upgrade-graphic"
      />
    </Box>
  );
};

export default SiaUpgradeBanner;
